module.exports = __webpack_public_path__ + "static/media/collaborate.700e7f49.png";